// Inert stub for the heavy @aurorasolar/ds deps this app never uses: slate*, react-table*,
// @dnd-kit/core|sortable|modifiers. next.config.ts aliases those packages to this file so they
// drop out of the client bundle (~160 KB compressed). DS pulls them in only for RichText / Table
// / FilmStrip / ReorderableList, which this app does not render. See CONS-2441; the real fix is
// making DS tree-shakeable (CONS-2277).
//
// TWO constraints make this stub non-obvious:
//
// 1. Must be inert, never throw. DS calls some of these at *module-eval* time, not just render
//    (e.g. `defaultDropAnimationSideEffects({...})` runs on every `import ... from
//    '@aurorasolar/ds'`). A stub that threw would crash every DS consumer on import.
//
// 2. Must use EXPLICIT named exports, not a Proxy. Turbopack statically analyzes a CJS module's
//    exports to build the ESM namespace for `import { X } from '...'`. A `module.exports = Proxy`
//    exposes no static names, so every named import resolves to `undefined` ("X is not a
//    function"). So we list every name DS imports from these packages (harvested from
//    @aurorasolar/ds/dist/index.esm.js), each pointing at one inert value.
//
// MAINTENANCE: the list is coupled to DS's private imports. If a DS upgrade imports a NEW name
// from these packages, it resolves to `undefined` and `yarn build` fails with "X is not a
// function" — re-harvest the names (grep `from "slate|react-table|@dnd-kit..."` in
// node_modules/@aurorasolar/ds/dist/index.esm.js) and add them here. To start using an excluded
// component, drop that package's alias from next.config.ts instead.

// One recursive inert value: calling, `new`-ing, and reading any property all yield `inert`
// again (so arbitrarily deep access/call/construct chains stay safe); coerces to ''. Note this
// is import-safe and access-safe but intentionally NOT render-safe: rendering one of the stubbed
// DS components (RichText / Table / FilmStrip / ReorderableList) throws at render. That is by
// design — this app never renders them, and a loud throw beats a silent broken render if that
// invariant is ever violated. We can't instead make components no-op, because some exports are
// called at module-eval time and the stub must be a single value that fits every usage shape.
const inert = new Proxy(function () {}, {
  apply: () => inert,
  construct: () => inert,
  get: (_t, prop) =>
    prop === Symbol.toPrimitive || prop === 'toString' || prop === 'valueOf'
      ? () => ''
      : typeof prop === 'symbol'
        ? undefined
        : inert,
});

module.exports = {
  __esModule: true,
  default: inert,
  // @dnd-kit/core
  DndContext: inert,
  DragOverlay: inert,
  KeyboardSensor: inert,
  MouseSensor: inert,
  TouchSensor: inert,
  closestCenter: inert,
  defaultAnnouncements: inert,
  defaultDropAnimationSideEffects: inert,
  useDroppable: inert,
  useSensor: inert,
  useSensors: inert,
  // @dnd-kit/modifiers
  restrictToHorizontalAxis: inert,
  // @dnd-kit/sortable
  SortableContext: inert,
  arrayMove: inert,
  horizontalListSortingStrategy: inert,
  sortableKeyboardCoordinates: inert,
  useSortable: inert,
  // slate
  Editor: inert,
  Element: inert,
  Node: inert,
  Path: inert,
  Point: inert,
  Range: inert,
  Text: inert,
  Transforms: inert,
  createEditor: inert,
  // slate-history
  withHistory: inert,
  // slate-react
  Editable: inert,
  ReactEditor: inert,
  Slate: inert,
  useReadOnly: inert,
  useSlate: inert,
  useSlateStatic: inert,
  withReact: inert,
  // react-table-sticky
  useSticky: inert,
  // react-table (imported as `import * as reactTable`; members read at render time)
  actions: inert,
  usePagination: inert,
  useResizeColumns: inert,
  useSortBy: inert,
  useTable: inert,
};
